"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.keys.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Popover = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _react2 = require("@emotion/react");
var _core = require("../../core");
var _theme = require("../../system/theme");
var _novo = require("../../theme/novo");
var _ODThemeLite = require("../../theme/ODThemeLite");
var _NavigationBar = require("./NavigationBar");
var _shared = require("./shared");
var _excluded = ["isOpen", "onRequestClose", "onBackClick", "title", "subtitle", "id", "headerIconButtonVariant", "primaryButtonProps", "secondaryButtonProps", "showDividers", "showOverlay", "stackCTAs", "analyticsName", "trackBoxImpression", "trackButtonImpressions", "hasPadding", "themeProps", "contentBgColor"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_1r3isrjpns() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Modal/Popover.tsx";
  var hash = "bff13ddf4945c1a60626cf9ae303a3d6cd7f1f49";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Modal/Popover.tsx",
    statementMap: {
      "0": {
        start: {
          line: 76,
          column: 25
        },
        end: {
          line: 76,
          column: 28
        }
      },
      "1": {
        start: {
          line: 77,
          column: 27
        },
        end: {
          line: 81,
          column: 1
        }
      },
      "2": {
        start: {
          line: 82,
          column: 27
        },
        end: {
          line: 86,
          column: 1
        }
      },
      "3": {
        start: {
          line: 88,
          column: 47
        },
        end: {
          line: 235,
          column: 1
        }
      },
      "4": {
        start: {
          line: 109,
          column: 2
        },
        end: {
          line: 109,
          column: 32
        }
      },
      "5": {
        start: {
          line: 111,
          column: 25
        },
        end: {
          line: 111,
          column: 91
        }
      },
      "6": {
        start: {
          line: 112,
          column: 20
        },
        end: {
          line: 112,
          column: 63
        }
      },
      "7": {
        start: {
          line: 114,
          column: 37
        },
        end: {
          line: 114,
          column: 47
        }
      },
      "8": {
        start: {
          line: 116,
          column: 45
        },
        end: {
          line: 132,
          column: 3
        }
      },
      "9": {
        start: {
          line: 134,
          column: 45
        },
        end: {
          line: 145,
          column: 3
        }
      },
      "10": {
        start: {
          line: 147,
          column: 23
        },
        end: {
          line: 168,
          column: 3
        }
      },
      "11": {
        start: {
          line: 170,
          column: 2
        },
        end: {
          line: 234,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 88,
            column: 47
          },
          end: {
            line: 88,
            column: 48
          }
        },
        loc: {
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 235,
            column: 1
          }
        },
        line: 108
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 89,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 89,
            column: 11
          },
          end: {
            line: 89,
            column: 16
          }
        }],
        line: 89
      },
      "1": {
        loc: {
          start: {
            line: 98,
            column: 2
          },
          end: {
            line: 98,
            column: 21
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 98,
            column: 17
          },
          end: {
            line: 98,
            column: 21
          }
        }],
        line: 98
      },
      "2": {
        loc: {
          start: {
            line: 99,
            column: 2
          },
          end: {
            line: 99,
            column: 20
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 99,
            column: 16
          },
          end: {
            line: 99,
            column: 20
          }
        }],
        line: 99
      },
      "3": {
        loc: {
          start: {
            line: 100,
            column: 2
          },
          end: {
            line: 100,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 100,
            column: 14
          },
          end: {
            line: 100,
            column: 19
          }
        }],
        line: 100
      },
      "4": {
        loc: {
          start: {
            line: 104,
            column: 2
          },
          end: {
            line: 104,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 104,
            column: 15
          },
          end: {
            line: 104,
            column: 19
          }
        }],
        line: 104
      },
      "5": {
        loc: {
          start: {
            line: 111,
            column: 25
          },
          end: {
            line: 111,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 111,
            column: 33
          },
          end: {
            line: 111,
            column: 64
          }
        }, {
          start: {
            line: 111,
            column: 67
          },
          end: {
            line: 111,
            column: 91
          }
        }],
        line: 111
      },
      "6": {
        loc: {
          start: {
            line: 112,
            column: 20
          },
          end: {
            line: 112,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 112,
            column: 37
          },
          end: {
            line: 112,
            column: 41
          }
        }, {
          start: {
            line: 112,
            column: 44
          },
          end: {
            line: 112,
            column: 63
          }
        }],
        line: 112
      },
      "7": {
        loc: {
          start: {
            line: 117,
            column: 16
          },
          end: {
            line: 117,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 117,
            column: 33
          },
          end: {
            line: 117,
            column: 58
          }
        }, {
          start: {
            line: 117,
            column: 61
          },
          end: {
            line: 117,
            column: 77
          }
        }],
        line: 117
      },
      "8": {
        loc: {
          start: {
            line: 144,
            column: 21
          },
          end: {
            line: 144,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 144,
            column: 35
          },
          end: {
            line: 144,
            column: 59
          }
        }, {
          start: {
            line: 144,
            column: 62
          },
          end: {
            line: 144,
            column: 75
          }
        }],
        line: 144
      },
      "9": {
        loc: {
          start: {
            line: 202,
            column: 9
          },
          end: {
            line: 214,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 202,
            column: 10
          },
          end: {
            line: 202,
            column: 21
          }
        }, {
          start: {
            line: 202,
            column: 25
          },
          end: {
            line: 202,
            column: 39
          }
        }, {
          start: {
            line: 202,
            column: 43
          },
          end: {
            line: 202,
            column: 48
          }
        }, {
          start: {
            line: 202,
            column: 52
          },
          end: {
            line: 202,
            column: 60
          }
        }, {
          start: {
            line: 203,
            column: 10
          },
          end: {
            line: 213,
            column: 12
          }
        }],
        line: 202
      },
      "10": {
        loc: {
          start: {
            line: 216,
            column: 16
          },
          end: {
            line: 216,
            column: 34
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 216,
            column: 29
          },
          end: {
            line: 216,
            column: 30
          }
        }, {
          start: {
            line: 216,
            column: 33
          },
          end: {
            line: 216,
            column: 34
          }
        }],
        line: 216
      },
      "11": {
        loc: {
          start: {
            line: 220,
            column: 9
          },
          end: {
            line: 231,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 220,
            column: 10
          },
          end: {
            line: 220,
            column: 28
          }
        }, {
          start: {
            line: 220,
            column: 32
          },
          end: {
            line: 220,
            column: 52
          }
        }, {
          start: {
            line: 221,
            column: 10
          },
          end: {
            line: 230,
            column: 13
          }
        }],
        line: 220
      },
      "12": {
        loc: {
          start: {
            line: 222,
            column: 13
          },
          end: {
            line: 222,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 222,
            column: 13
          },
          end: {
            line: 222,
            column: 25
          }
        }, {
          start: {
            line: 222,
            column: 29
          },
          end: {
            line: 222,
            column: 40
          }
        }],
        line: 222
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0, 0, 0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "bff13ddf4945c1a60626cf9ae303a3d6cd7f1f49"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1r3isrjpns = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1r3isrjpns();
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// For the CTA props, `variant` is not allowed. `analyticsName` and `aria-label` are optional because we provide defaults

// To meet accessibility standards, the Popover component must receive either title, aria-labelledby, or aria-label.

var CLOSE_TIMEOUT_MS = (cov_1r3isrjpns().s[0]++, 500);
var CONTENT_CLASS_NAME = (cov_1r3isrjpns().s[1]++, {
  base: 'BricksPopover__Content',
  afterOpen: 'BricksPopover__Content--after-open',
  beforeClose: 'BricksPopover__Content--before-close'
});
var OVERLAY_CLASS_NAME = (cov_1r3isrjpns().s[2]++, {
  base: 'BricksPopover__Overlay',
  afterOpen: 'BricksPopover__Overlay--after-open',
  beforeClose: 'BricksPopover__Overlay--before-close'
});
cov_1r3isrjpns().s[3]++;
var Popover = exports.Popover = function Popover(_ref) {
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? (cov_1r3isrjpns().b[0][0]++, false) : _ref$isOpen,
    onRequestClose = _ref.onRequestClose,
    onBackClick = _ref.onBackClick,
    title = _ref.title,
    subtitle = _ref.subtitle,
    id = _ref.id,
    headerIconButtonVariant = _ref.headerIconButtonVariant,
    primaryButtonProps = _ref.primaryButtonProps,
    secondaryButtonProps = _ref.secondaryButtonProps,
    _ref$showDividers = _ref.showDividers,
    showDividers = _ref$showDividers === void 0 ? (cov_1r3isrjpns().b[1][0]++, true) : _ref$showDividers,
    _ref$showOverlay = _ref.showOverlay,
    showOverlay = _ref$showOverlay === void 0 ? (cov_1r3isrjpns().b[2][0]++, true) : _ref$showOverlay,
    _ref$stackCTAs = _ref.stackCTAs,
    stackCTAs = _ref$stackCTAs === void 0 ? (cov_1r3isrjpns().b[3][0]++, false) : _ref$stackCTAs,
    analyticsName = _ref.analyticsName,
    trackBoxImpression = _ref.trackBoxImpression,
    trackButtonImpressions = _ref.trackButtonImpressions,
    _ref$hasPadding = _ref.hasPadding,
    hasPadding = _ref$hasPadding === void 0 ? (cov_1r3isrjpns().b[4][0]++, true) : _ref$hasPadding,
    themeProps = _ref.themeProps,
    contentBgColor = _ref.contentBgColor,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_1r3isrjpns().f[0]++;
  cov_1r3isrjpns().s[4]++;
  (0, _shared.useDisabledBodyScroll)(isOpen);
  var ariaLabelledBy = (cov_1r3isrjpns().s[5]++, title ? (cov_1r3isrjpns().b[5][0]++, (0, _NavigationBar.getNavigationBarTitleId)({
    id: id
  })) : (cov_1r3isrjpns().b[5][1]++, props['aria-labelledby']));
  var ariaLabel = (cov_1r3isrjpns().s[6]++, ariaLabelledBy ? (cov_1r3isrjpns().b[6][0]++, null) : (cov_1r3isrjpns().b[6][1]++, props['aria-label']));
  var _ref2 = (cov_1r3isrjpns().s[7]++, (0, _theme.useTheme)()),
    shadows = _ref2.shadows,
    radii = _ref2.radii,
    colors = _ref2.colors;
  var contentStyles = (cov_1r3isrjpns().s[8]++, {
    background: contentBgColor ? (cov_1r3isrjpns().b[7][0]++, _novo.colors[contentBgColor]) : (cov_1r3isrjpns().b[7][1]++, colors.neutrals0),
    WebkitOverflowScrolling: 'touch',
    outline: 'none',
    border: 'none',
    position: 'absolute',
    inset: 'auto',
    padding: 0,
    boxShadow: shadows.z2,
    borderRadius: radii.semiRounded,
    display: 'flex',
    flexDirection: 'column',
    // Popovers do not allow scrolling. Use full-screen modal if content overflows.
    overflow: 'hidden',
    maxHeight: 'calc(100vh - 48px)',
    maxWidth: 'calc(100vw - 48px)'
  });
  var overlayStyles = (cov_1r3isrjpns().s[9]++, {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 999,
    backgroundColor: showOverlay ? (cov_1r3isrjpns().b[8][0]++, 'rgba(34, 34, 34, 0.60)') : (cov_1r3isrjpns().b[8][1]++, 'transparent')
  });
  var globalStyles = (cov_1r3isrjpns().s[10]++, /*#__PURE__*/(0, _react2.css)(".", OVERLAY_CLASS_NAME.base, "{opacity:0;transition:opacity ", CLOSE_TIMEOUT_MS, "ms ease-out;}.", OVERLAY_CLASS_NAME.afterOpen, "{opacity:1;}.", OVERLAY_CLASS_NAME.beforeClose, "{opacity:0;}.", CONTENT_CLASS_NAME.base, "{transform:translateY(10%);transition:transform ", CLOSE_TIMEOUT_MS, "ms ease-out;}.", CONTENT_CLASS_NAME.afterOpen, "{transform:translateY(0);}.", CONTENT_CLASS_NAME.beforeClose, "{transform:translateY(10%);}" + (process.env.NODE_ENV === "production" ? "" : ";label:globalStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
  cov_1r3isrjpns().s[11]++;
  return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    shouldCloseOnOverlayClick: showOverlay,
    className: CONTENT_CLASS_NAME,
    overlayClassName: OVERLAY_CLASS_NAME,
    closeTimeoutMS: CLOSE_TIMEOUT_MS,
    style: {
      content: contentStyles,
      overlay: overlayStyles
    }
    /*
      Accessibility note: Aria-model indicates the presence of a modal element
      https://www.w3.org/TR/wai-aria-1.2/#aria-modal
    */,
    "aria-modal": isOpen
    /*
      Accessibility note: use the contentLabel prop to provide a label for the modal content
      If the modal is already labeled with visible text, you should specify the element including the label with the aria-labelledby attribute.
      https://reactcommunity.org/react-modal/accessibility/#aria-attributes
      To set aria-labelledby, either (1) pass headerProps.title and let this component set aria-labelledby for you, or (2) pass ariaLabelledBy
      and set it to the id of your custom label
    */,
    aria: {
      labelledby: ariaLabelledBy
    },
    contentLabel: ariaLabel
  }, /*#__PURE__*/_react["default"].createElement(_react2.Global, {
    styles: globalStyles
  }), /*#__PURE__*/_react["default"].createElement(_ODThemeLite.ThemedLite, themeProps, ((cov_1r3isrjpns().b[9][0]++, onBackClick) || (cov_1r3isrjpns().b[9][1]++, onRequestClose) || (cov_1r3isrjpns().b[9][2]++, title) || (cov_1r3isrjpns().b[9][3]++, subtitle)) && (cov_1r3isrjpns().b[9][4]++, /*#__PURE__*/_react["default"].createElement(_shared.ModalHeader, {
    trackButtonImpressions: trackButtonImpressions,
    analyticsName: analyticsName,
    onBackClick: onBackClick,
    onRequestClose: onRequestClose,
    title: title,
    subtitle: subtitle,
    id: id,
    showDivider: showDividers,
    headerIconButtonVariant: headerIconButtonVariant
  })), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    p: hasPadding ? (cov_1r3isrjpns().b[10][0]++, 5) : (cov_1r3isrjpns().b[10][1]++, 0),
    maxWidth: "960px",
    maxHeight: "530px",
    overflow: "hidden"
  }, props.children), ((cov_1r3isrjpns().b[11][0]++, primaryButtonProps) || (cov_1r3isrjpns().b[11][1]++, secondaryButtonProps)) && (cov_1r3isrjpns().b[11][2]++, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (cov_1r3isrjpns().b[12][0]++, showDividers) && (cov_1r3isrjpns().b[12][1]++, /*#__PURE__*/_react["default"].createElement(_core.Divider, null)), /*#__PURE__*/_react["default"].createElement(_shared.ModalFooter, {
    stackCTAs: stackCTAs,
    primaryButtonProps: primaryButtonProps,
    secondaryButtonProps: secondaryButtonProps,
    analyticsName: analyticsName
  })))));
};
var _default = exports["default"] = Popover;